import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { AutenticationService } from './../../autentication/autentication.service';
import { Auth } from './../../autentication/Auth';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, Input } from '@angular/core';
import { TweenMax } from 'gsap';
import { EventTypes } from '../EventTypes';

@Component({
	selector: 'app-signature',
	templateUrl: './signature.component.html',
	styleUrls: ['./signature.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SignatureComponent implements OnInit {

	@Input() payDayShow: boolean;
	@Input() submited: boolean;
	@Output() onSetForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Input() disabled = false;
	@Input() showTokenInput = true;
	form: FormGroup;
	inputToKeypadSendValue: any;
	activeInput: any;
	isTransactionUser: boolean;

	@Input() assText = 'Digite suas informações de segurança:';

	tokenMessage: string;

	constructor(private formBuilder: FormBuilder, private authService: AutenticationService) {
		this.form = formBuilder.group({
			'eletronicSignature': ['', Validators.required]
		});
	}

	ngOnInit() {
		this.inputToKeypadSendValue = this.form.get('eletronicSignature');
		this.onSetForm.emit(this.form);
		this.activeInput = this.form.controls.eletronicSignature;

		if (Auth.getInstance().getUser().rule === 'TRANSACIONAR' && this.showTokenInput) {
			this.isTransactionUser = true;
			this.form.addControl('token', new FormControl('', Validators.required));
		} else {
			if (this.form.controls.token) {
				this.form.removeControl('token');
			}
		}

		this.sendSmsToken();


	}

	sendSmsToken() {
		if (Auth.getInstance().getUser().tokenSms) {

			AppEventDispatcher.dispatch(EventTypes.PRELOAD, { show: true });

			this.authService.requestTokenSMS().subscribe((data: any) => {
				this.tokenMessage = data.Mensagem;
				AppEventDispatcher.dispatch(EventTypes.PRELOAD, { show: false });
			}, () => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK,
					{ msg: 'Erro ao solicitar token por SMS, por favor, clique no botão reenviar token.' });
			});
		}
	}

	keyDownHandler(event: Event) {
		event.preventDefault();
	}

	setInput(input) {
		this.inputToKeypadSendValue = this.form.get(input);
	}

	setInputValueFromKeyPad(val) {
		if (this.inputToKeypadSendValue.value.length <= 5) {
			this.inputToKeypadSendValue.setValue(this.inputToKeypadSendValue.value.toString() + val[0].toString());
			$('[data-component="signature"]').find('.eletronicSignature').focus();
		}
	}

	changeToToken() {
		if (this.form.controls.eletronicSignature.valid) {
			$('[data-component="signature"]').find('.token').focus();
		}
	}

	onCorrect() {
		this.inputToKeypadSendValue.setValue('');
		$('[data-component="signature"]').find('.eletronicSignature').focus();
	}

	showNumPad() {
		TweenMax.to('[data-component="signature"] [data-component="virtual-num-pad"]', .5, {autoAlpha: 1} );
	}

	hideNumPad(e) {
		if (e.relatedTarget === null || e.relatedTarget.className !== 'keyboard-button') {
			TweenMax.to('[data-component="signature"] [data-component="virtual-num-pad"]', .5, { autoAlpha: 0 });
		}
	}

	hideNumPadFromToken() {
		TweenMax.to('[data-component="signature"] [data-component="virtual-num-pad"]', .5, { autoAlpha: 0 });
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/signature/signature.component.ts